<template>
  <b-modal :title="helper.trans('labels.reattach_counterparty')"
           dialog-class="modal-lg"
           :modelValue="isVisible"
           footer-class="d-flex justify-content-end"
           @update:modelValue="isVisible = $event">
    <template #default>
      <LoaderWrapper ref="loader" class="h-100">
        <div class="p-3 pt-0">
          <div class="overflow-auto">
            <table class="table table-striped border-light align-middle text-left position-relative">
              <thead>
              <tr>
                <th class="text-capitalize-first">{{ helper.trans('labels.requisites') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.currency') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.holderName') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.method') }}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(req, index) in availableRequisites" :key="index" class="">
                <td>{{ req.requisites }}</td>
                <td>{{ req.currency }}</td>
                <td>{{ req.holderName }}</td>
                <td>{{ helper.trans('pay_methods.' + req.method) }}</td>
                <td class="text-end">
                  <button type="button" @click="selectRequisite(req.id)" class="btn btn-sm btn-outline-primary text-nowrap text-capitalize-first">
                    {{ helper.trans('labels.select') }}
                  </button>
                </td>
              </tr>
              <tr v-if="availableRequisites.length === 0">
                <td colspan="5" class="text-center text-muted py-3">
                  {{ helper.trans('labels.no_available_requisites') }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </LoaderWrapper>
    </template>
    <template #footer>
      <button type="button" @click.prevent="hide" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{ helper.trans('button.cancel') }}
      </button>
    </template>
  </b-modal>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import {BModal} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";

export default defineComponent({
  components: {
    LoaderWrapper,
    BModal,
  },
  emits: ['selected'],
  setup(props, {emit}) {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const isVisible = ref<boolean>(false)
    const currentUserId = ref<string | null>(null)
    const availableRequisites = ref<TraderRequisitesDTO[]>([])

    const show = (userId: string, requisites: TraderRequisitesDTO[]) => {
      currentUserId.value = userId
      availableRequisites.value = requisites
      isVisible.value = true
    }

    const hide = () => {
      isVisible.value = false
      currentUserId.value = null
      availableRequisites.value = []
    }

    const selectRequisite = (requisiteId: number) => {
      if (currentUserId.value) {
        emit('selected', currentUserId.value, requisiteId)
        hide()
      }
    }

    return {
      loader,
      isVisible,
      availableRequisites,
      show,
      hide,
      selectRequisite,
      helper
    }
  }
})
</script>
